module.exports = __webpack_public_path__ + "static/media/food@2x.0da2abbe.png";